export const dataSuppliers =  [
  {
    id: '94603',
    label: 'UNILEVER FRANCE - PF',
  },
  {
    id: 'AP15204',
    label: 'PRESSE EDITION COMMUNICATION',
  },
  {
    id: 'AP31464',
    label: 'DELTA COMMUNICATION',
  },
  {
    id: '34269',
    label: 'PUNICE TRADING COMPANY LIMITED',
  },
  {
    id: '94168',
    label: 'UNION TOP CO.,LTD. (OO)',
  },
  {
    id: '95740',
    label: 'TRI-UNION (USA) INC. (OO)',
  },
  {
    id: '95072',
    label: 'UNIVERSAL EXPORTS (OO)',
  },
  {
    id: '95602',
    label: 'UNITED OVERSEAS INDUSTRIAL LTD',
  },
  {
    id: '93807',
    label: 'SIGAL(TUNISIE)(OO)',
  },
  {
    id: 'AP41696',
    label: 'NAT KING CONSEIL - L\'UNIVERS D',
  },
  {
    id: 'AP34936',
    label: 'CATHERINE COTE&THOMAS JOUNIN',
  },
  {
    id: 'AP41325',
    label: 'PRESSE MEDIA COMMUNICATION - L',
  },
  {
    id: 'AP40879',
    label: 'UNION DES EDITIONS PROFESSIONN',
  },
  {
    id: 'AP40855',
    label: 'TRAIT D\'UNION RESERVATION',
  },
  {
    id: 'AP40627',
    label: 'UNION SPORTIVE CHEVRIERES-GRAN',
  },
  {
    id: 'AP40350',
    label: 'SOC MUNICIPALE OMNISPORTS CULT',
  },
  {
    id: 'AP40244',
    label: 'INSTITUT DE COMMUNICATION APPL',
  },
  {
    id: '34138',
    label: 'UNIGLORY ACCESSORIES LTD(OO)',
  },
  {
    id: 'AP39591',
    label: 'IDENTITY COMMUNICATION',
  },
  {
    id: 'AP39444',
    label: 'UNION ALLIANCE ALSACE-ORIGINE',
  },
  {
    id: 'AP39422',
    label: 'EUROFF 7 COMMUNICATION - SARL',
  },
  {
    id: 'AP39097',
    label: 'AUNILEC',
  },
  {
    id: 'AP38733',
    label: 'PERSPECTIVES SARL UNIPERSONNEL',
  },
  {
    id: 'AP38644',
    label: 'MG COMMUNICATION-COM ADVANCE',
  },
  {
    id: 'AP38431',
    label: 'UNIVERS PRODUCTIQUE SAS',
  },
  {
    id: '25681',
    label: 'UNION VIGNERONS COTES LUBERON',
  },
  {
    id: 'AP42114',
    label: 'SERVICE COMMUNICATION',
  },
  {
    id: 'AP30707',
    label: 'UNIVERSITE UPEC',
  },
  {
    id: '94724',
    label: 'UNIFLEX TRADING CO LTD (OO)',
  },
  {
    id: '95820',
    label: 'UNION WELL INDUSTRIAL CO.LTD.(',
  },
  {
    id: 'AP39747',
    label: 'ASSOC ENTRAIDE UNIVERSITAIRE',
  },
  {
    id: 'AP25247',
    label: 'ELLIPSE COMMUNICATION',
  },
  {
    id: '93911',
    label: 'UNITED TRADING CIE(OO)',
  },
  {
    id: '96400',
    label: 'REUNION CLOTHING COMPANY(OO)',
  },
  {
    id: 'AP41164',
    label: 'HUISSIERS REUNIS - DAVID DI FA',
  },
  {
    id: 'AP40700',
    label: '106 TRAITS D\'UNION ASSOCIATION',
  },
  {
    id: 'AP40632',
    label: 'ED COMMUNICATION SARL',
  },
  {
    id: 'AP40530',
    label: 'LA SANTE AU TRAVAIL DE L AUNIS',
  },
  {
    id: 'AP40254',
    label: 'INS.REG. UNIVERSIT. POLYTECHN.',
  },
  {
    id: '34141',
    label: 'NINGBO SOFINE UNION HOME DECOR',
  },
  {
    id: 'AP39647',
    label: 'ELMACOMMUNICATION',
  },
  {
    id: 'AP39427',
    label: 'EUROPEENNE DE COMMUNICATION PU',
  },
  {
    id: 'AP39462',
    label: 'P.C.C - PRESSE CORSE COMMUNICA',
  },
  {
    id: 'AP39446',
    label: 'ALTOUNIAN DEPANNAGE AUTO ET ME',
  },
  {
    id: 'AP39250',
    label: 'TARD.IEU COMMUNICATION',
  },
  {
    id: 'AP39042',
    label: 'AGIR COMMUNICATION',
  },
  {
    id: 'AP38694',
    label: 'UNIVERSITE CLERMONT AUVERGNE',
  },
  {
    id: 'AP38516',
    label: 'BBG COMMUNICATION SARL',
  },
  {
    id: '42898',
    label: 'UNION DE GUYENNE COOPERATIVES',
  },
  {
    id: 'AP38184',
    label: 'RTS COMMUNICATION SARL',
  },
  {
    id: '62046',
    label: 'PANASONIC ENERGY EUROPE NV.',
  },
  {
    id: 'AP25543',
    label: 'JMP EXPANSION',
  },
  {
    id: '34270',
    label: 'THE BOURGINI COMPANY B.V.',
  },
  {
    id: '34269',
    label: 'PUNICE TRADING COMPANY LIMITED',
  },
  {
    id: '94682',
    label: 'TOPMAX COMPANY LTD (OO)',
  },
  {
    id: 'AP00896',
    label: 'ESPACE EXPANSION SAS',
  },
  {
    id: '93698',
    label: 'CONTINENTAL PANJIPRATAMA PT. (',
  },
  {
    id: '34205',
    label: 'SUMEC TEXTILE COMPANY LIMITED',
  },
  {
    id: 'AP39967',
    label: 'DEPANN\'EXPRESS SAS',
  },
  {
    id: 'AP39378',
    label: 'RMS DEPANNAGE SARL',
  },
  {
    id: 'AP38889',
    label: 'ZOLPAN SAS',
  },
  {
    id: 'AP38588',
    label: 'THE BUBBLES COMPANY',
  },
  {
    id: '01781',
    label: 'D AUCY COMPANY',
  },
  {
    id: 'AP41875',
    label: 'PANORAMEN',
  },
  {
    id: '98104',
    label: 'SOVENA ESPANA SA',
  },
  {
    id: '93796',
    label: 'SAN PUI KEI TRADING COMPANY(OO',
  },
  {
    id: '96350',
    label: 'FELICIA COMPANY LIMITED(OO)',
  },
  {
    id: '96400',
    label: 'REUNION CLOTHING COMPANY(OO)',
  },
  {
    id: 'AP41370',
    label: 'ADOPTEUNPANNEAU.COM',
  },
  {
    id: '79284',
    label: 'PANADIS SARL',
  },
  {
    id: '34198',
    label: 'CAPESPAN CONTINENT NV',
  },
  {
    id: '43180',
    label: 'PLAZA DE ESPANA SARL - COMPTOI',
  },
  {
    id: 'AP40113',
    label: 'USIPANEL',
  },
  {
    id: 'AP40003',
    label: 'NYNY COMPANY',
  },
  {
    id: 'AP39620',
    label: 'WAVE PANDA',
  },
  {
    id: 'AP39446',
    label: 'ALTOUNIAN DEPANNAGE AUTO ET ME',
  },
  {
    id: 'AP39118',
    label: 'PANITECH',
  },
  {
    id: 'AP38937',
    label: 'INVEST HOTELS SNC  CAMPANILE',
  },
  {
    id: 'AP38770',
    label: 'PANORAMA LAL SASU',
  },
  {
    id: 'AP38614',
    label: 'V2D EXPANSION SARL',
  },
  {
    id: 'AP38607',
    label: 'PANTEL MATTHIEU GEORGES BERNAR',
  },
  {
    id: 'AP38274',
    label: 'DU PANORAMA SAS',
  },
  {
    id: 'AP41986',
    label: 'ASSISTANCE DEPANNAGE SERVICES',
  },
  {
    id: 'AP41972',
    label: 'LHG SEYSSINS - CAMPANILLE',
  },
  {
    id: '94224',
    label: 'ANAVIL COMPANY LTD (OO)',
  },
  {
    id: '94203',
    label: 'MASTER TOY COMPANY LTD (OO)',
  },
  {
    id: '96180',
    label: 'PANCA BROTHERSCENTRAL GARM.PT',
  },
  {
    id: '95995',
    label: 'ASIA TRADING COMPANY (OO)',
  },
  {
    id: '94601',
    label: 'ALOT ENTERPRISE COMPANY (OO)',
  },
  {
    id: '95641',
    label: 'SEASTAR INDUSTRIES COMPANY (OO',
  },
  {
    id: '95098',
    label: 'ALPAN TEKSTIL VE KONFEKSIYON (',
  },
  {
    id: '93989',
    label: 'PANTJATUNGGAL KNITTING MILL PT',
  },
  {
    id: 'AP41393',
    label: 'DEPAN\'RESTO',
  },
  {
    id: '34229',
    label: 'PANADERO AB',
  },
  {
    id: 'AP40913',
    label: 'SEALS COMPANY SARL',
  },
  {
    id: 'AP40853',
    label: 'HBHS - DEPANNAGE RIDEAUX METAL',
  },
  {
    id: 'AP40338',
    label: 'LAPEERE SEBASTIEN - DEPANNAGE',
  },
  {
    id: '34156',
    label: 'SCAVI HUE COMPANY',
  },
  {
    id: 'AP38881',
    label: 'MONTROUGE EXPANSION SARL',
  },
  {
    id: '79002',
    label: 'CAPESPAN CONTINENT (OO)',
  },
  {
    id: 'AP40648',
    label: 'COMITE D ENTREPRISE AUCHAN FRA',
  },
  {
    id: 'AP40300',
    label: 'VAUCLUSE THERMIQUE SANITAIRE S',
  },
  {
    id: '79048',
    label: 'AUCHAN SUPERMARCHE PARIS VOLTA',
  },
  {
    id: '78978',
    label: 'AUCHAN SUPERMARCHE VILLERS BRE',
  },
  {
    id: '78977',
    label: 'AUCHAN SUPERMARCHE GRENOBLE VI',
  },
  {
    id: '78972',
    label: 'AUCHAN SUPERMARCHE COURNON LES',
  },
  {
    id: '01781',
    label: 'D AUCY COMPANY',
  },
  {
    id: 'AP41632',
    label: 'TOULOUSE LALANDE AUCAMVILLE XV',
  },
  {
    id: 'AP41276',
    label: 'FAUCHILLE PLOMBERIE',
  },
  {
    id: 'AP40447',
    label: 'EURAUCHAN',
  },
  {
    id: '79050',
    label: 'AUCHAN SUPERMARCHE WINTZENHEIM',
  },
  {
    id: '79049',
    label: 'AUCHAN SUPERMARCHE VITRY SUR S',
  },
  {
    id: '78979',
    label: 'AUCHAN SUPERMARCHE VOIRON',
  },
  {
    id: '78975',
    label: 'AUCHAN SUPERMARCHE TOURNUS',
  },
  {
    id: '78976',
    label: 'AUCHAN SUPERMARCHE LE VAL DE R',
  },
  {
    id: '78973',
    label: 'AUCHAN SUPERMARCHE TOULOUSE PT',
  },
  {
    id: '78966',
    label: 'AUCHAN SUPERMARCHE TOURS SAINT',
  },
  {
    id: '78965',
    label: 'AUCHAN SUPERMARCHE SARTROUVILL',
  },
  {
    id: '78963',
    label: 'AUCHAN SUPERMARCHE SAINT MAUR',
  },
  {
    id: '78960',
    label: 'AUCHAN SUPERMARCHE TOURS SANIT',
  },
  {
    id: '78957',
    label: 'AUCHAN SUPERMARCHE LE PONTET',
  },
  {
    id: '78954',
    label: 'AUCHAN SUPERMARCHE PARIS OURCQ',
  },
  {
    id: '78951',
    label: 'AUCHAN SUPERMARCHE NOISY LE SE',
  },
  {
    id: '78948',
    label: 'AUCHAN SUPERMARCHE MOUVAUX',
  },
  {
    id: '78947',
    label: 'AUCHAN SUPERMARCHE MUTZIG',
  },
  {
    id: '78944',
    label: 'AUCHAN SUPERMARCHE MONTROUGE',
  },
  {
    id: '45704',
    label: 'FAUCHON SA',
  },
  {
    id: 'AP41905',
    label: 'LYCEE POLYVALENT VAUCANSON - G',
  },
  {
    id: '79120',
    label: 'AUCHAN ENTREPOT PGC COURNON',
  },
  {
    id: 'AP38803',
    label: 'FAUCHER ALAIN - ALFATECH',
  },
  {
    id: '79052',
    label: 'AUCHAN SUPERMARCHE WISSEMBOURG',
  },
  {
    id: '78974',
    label: 'AUCHAN SUPERMARCHE TRIEL SUR S',
  },
  {
    id: '78971',
    label: 'AUCHAN SUPERMARCHE PARIS TOLBI',
  },
  {
    id: '78970',
    label: 'AUCHAN SUPERMARCHE TOURNEFEUIL',
  },
  {
    id: '78969',
    label: 'AUCHAN SUPERMARCHE MEULAN TESS',
  },
  {
    id: '78968',
    label: 'AUCHAN SUPERMARCHE TERRASSON',
  },
  {
    id: '78967',
    label: 'AUCHAN SUPERMARCHE TASSIN LA D',
  },
  {
    id: '78962',
    label: 'AUCHAN SUPERMARCHE SAINT PIERR',
  },
  {
    id: '78958',
    label: 'AUCHAN SUPERMARCHE TOURS RABEL',
  },
  {
    id: '78956',
    label: 'AUCHAN SUPERMARCHE GRENOBLE PE',
  },
  {
    id: '78953',
    label: 'AUCHAN SUPERMARCHE ORGERUS',
  },
  {
    id: '78952',
    label: 'AUCHAN SUPERMARCHE OBERNAI',
  },
  {
    id: '78945',
    label: 'AUCHAN SUPERMARCHE LES MARTRES',
  },
  {
    id: '78964',
    label: 'AUCHAN SUPERMARCHE SAINT SAULV',
  },
  {
    id: '78961',
    label: 'AUCHAN SUPERMARCHE SUCY EN BRI',
  },
  {
    id: '78959',
    label: 'AUCHAN SUPERMARCHE SACLAY',
  },
  {
    id: '78955',
    label: 'AUCHAN SUPERMARCHE STRASBOURG',
  },
  {
    id: '78950',
    label: 'AUCHAN SUPERMARCHE NOYELLES LE',
  },
  {
    id: '78949',
    label: 'AUCHAN SUPERMARCHE STRASBOURG',
  },
  {
    id: '78946',
    label: 'AUCHAN SUPERMARCHE STRASBOURG',
  },
]
